// ======================================================================
// File Name       : ServiceGroupServiceList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import {
  Form,
  Button,
  Col,
  Row,
  Table
} from 'react-bootstrap';
import { connect } from 'react-redux';

class ServiceGroupServiceList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate = this.props.searchResultService === nextProps.searchResultService &&
      this.props.checkedServiceOnPage === nextProps.checkedServiceOnPage &&
      this.props.editingServiceGroupService === nextProps.editingServiceGroupService 
    return !shouldNotUpdate;
  }

  render() {
    const { searchResultService, editingServiceGroupService, checkedServiceOnPage } = this.props;
    return (
      <div>
        {searchResultService && searchResultService.allServiceCds.length > 0 && <>
          <Row className="margin-top-10">
            <Col sm={2}>
              <Button variant="default" onClick={this.props.handleCheckAll}>全選択/解除</Button>
            </Col>
          </Row>

          <Table striped hover className="margin-top-7 margin-bottom-10">
            <thead>
              <tr>
                <th className="col-md-1" />
                <th>サービスコード</th>
                <th>サービス名</th>
              </tr>
            </thead>
            <tbody>
              {searchResultService.allServiceCds.map((serviceCd, index) => {
                const service = searchResultService.byServiceCd[serviceCd];
                const checked = checkedServiceOnPage.indexOf(serviceCd) > -1;
                return (
                  <tr key={index}>
                    <td>
                      <Form.Check
                        type='checkbox'
                        className="text-center margin-clear"
                        value={serviceCd}
                        checked={!!editingServiceGroupService[serviceCd] || checked}
                        onChange={this.props.handleServiceCheck} />
                    </td>
                    <td>{service.serviceCd}</td>
                    <td>{service.serviceName}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

        </>}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authority } = state;
  return { group, authority: authority.authorityInfo };
};
export default connect(mapStateToProps)(ServiceGroupServiceList);
